<div [formGroup]="form" class="row">
  <!-- Unit number -->
  <div class="col-4">
    <mat-form-field>
      <mat-label>Unit No.</mat-label>
      <input matInput formControlName="unitNumber" type="number" min="0" placeholder="Enter unit number">
    </mat-form-field>
  </div>
  <!-- Address -->
  <div class="col-4">
    <mat-form-field>
      <mat-label>Street No.</mat-label>
      <input matInput formControlName="streetNumber" placeholder="Enter street number">
      <mat-error>
        <app-validation-error [errors]="form.get('streetNumber').errors"></app-validation-error>
        <!-- @TODO Alex/Mikhail/Artem (TT-2471): implement validators with built-in messages -->
        @if (form.get('streetNumber').hasError('pattern')) {
          Spaces are not allowed
        }
      </mat-error>
    </mat-form-field>
  </div>
  <div class="col-4">
    <mat-form-field>
      <mat-label>Address</mat-label>
      <input matInput formControlName="street" placeholder="Enter street name">
      <mat-error>
        <app-validation-error [errors]="form.get('street').errors"></app-validation-error>
      </mat-error>
    </mat-form-field>
  </div>
  <!-- City -->
  <div class="col-4">
    <mat-form-field>
      <mat-label>Suburb</mat-label>
      <input matInput formControlName="city" placeholder="Enter locality name">
      <mat-error>
        <app-validation-error [errors]="form.get('city').errors"></app-validation-error>
      </mat-error>
    </mat-form-field>
  </div>
  <!-- State -->
  <div class="col-4">
    <mat-form-field>
      <mat-label>State</mat-label>
      @if (form.isCorelogicAvailable()) {
        <mat-select formControlName="state" placeholder="Select state">
          @for (state of (states | keyvalue); track state) {
            <mat-option [value]="state.key">{{state.value}}</mat-option>
          }
        </mat-select>
      } @else {
        <input matInput formControlName="state" placeholder="Enter state">
      }
      <mat-error>
        <app-validation-error [errors]="form.get('state').errors"></app-validation-error>
      </mat-error>
    </mat-form-field>
  </div>
  <!-- Postal code -->
  <div class="col-4">
    <mat-form-field>
      <mat-label>Postal code</mat-label>
      <input matInput formControlName="postcode" placeholder="Postal Code">
      <mat-error>
        <app-validation-error [errors]="form.get('postcode').errors"></app-validation-error>
      </mat-error>
    </mat-form-field>
  </div>
</div>
